import React, { useEffect, useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { supabaseHelpers } from '../../../lib/supabase';
import { useAuth } from '../../../contexts/AuthContext';
import { useConfirm } from '../../../contexts/ConfirmContext';

const MarketplaceCard = ({ marketplace, onUpdated }) => {
  const { user } = useAuth();
  const { confirm } = useConfirm();
  const [stats, setStats] = useState({ usageCount: 0, allocatedUnits: 0, allocatedValue: 0, totalValue: 0 });

  useEffect(() => {
    let cancelled = false;
    const loadStats = async () => {
      const { data } = await supabaseHelpers?.getMarketplaceStats(marketplace?.id, user?.id);
      if (!cancelled && data) setStats(data);
    };
    loadStats();
    return () => { cancelled = true; };
  }, [marketplace?.id, user?.id]);

  const handleToggleActive = async () => {
    await supabaseHelpers?.updateMarketplace(marketplace?.id, { active: !marketplace?.active });
    onUpdated?.();
  };

  const handleDelete = async () => {
    const ok = await confirm({
      title: 'Remover marketplace',
      message: 'Remover este marketplace?',
      confirmText: 'Remover',
      cancelText: 'Cancelar',
      variant: 'destructive'
    });
    if (!ok) return;
    await supabaseHelpers?.deleteMarketplace(marketplace?.id);
    onUpdated?.();
  };

  const inactive = marketplace?.active === false;
  return (
    <div className={`calculator-card border-border ${inactive ? 'opacity-60 grayscale' : ''}`}>
      <div className="flex items-start justify-between">
        <div>
          <h4 className="font-semibold text-foreground flex items-center space-x-2">
            <Icon name="ShoppingCart" size={16} className="text-primary" />
            <span>{marketplace?.name}</span>
            {inactive && (
              <span className="ml-2 px-2 py-0.5 text-xs rounded bg-muted text-muted-foreground">Inativo</span>
            )}
          </h4>
          {marketplace?.platform_url && (
            <a href={marketplace?.platform_url} target="_blank" rel="noreferrer" className="text-xs text-muted-foreground hover:underline">
              {marketplace?.platform_url}
            </a>
          )}
          <div className="mt-3 text-sm text-muted-foreground">
            <div>Taxa por transação: {parseFloat(marketplace?.fee_percent || 0)?.toFixed(1)}%</div>
            <div>Taxa fixa por transação: R$ {parseFloat(marketplace?.fixed_fee_per_unit || 0)?.toFixed(2)}</div>
            <div className="mt-3 flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <Icon name="BarChart2" size={14} className="text-muted-foreground" />
                <span>Usado em projetos: {stats?.usageCount || 0}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Package" size={14} className="text-muted-foreground" />
                <span>Peças alocadas: {stats?.allocatedUnits || 0}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="DollarSign" size={14} className="text-muted-foreground" />
                <span>Valor total: R$ {parseFloat((stats?.allocatedValue ?? stats?.totalValue) || 0)?.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <Button size="sm" variant="outline" onClick={handleToggleActive}>
            {marketplace?.active ? 'Desativar' : 'Ativar'}
          </Button>
          <Button size="sm" variant="destructive" iconName="Trash2" onClick={handleDelete}>
            Remover
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MarketplaceCard;